"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientHandshake = void 0;
const endpoints_1 = require("./endpoints");
class ClientHandshake {
    constructor(ipcBus) {
        this.ipcBus = ipcBus;
    }
    async connect(channel) {
        await this.ipcBus.connect();
        return new Promise(resolve => {
            const pingIntervalId = setInterval(() => this.sendPing(channel), 10000);
            const subscription = this.ipcBus.subscribe(channel + endpoints_1.PONG_ENDPOINT, () => {
                resolve();
                clearInterval(pingIntervalId);
                subscription.unsubscribe();
            });
            this.sendPing(channel);
        });
    }
    sendPing(channel) {
        this.ipcBus.publish(channel + endpoints_1.PING_ENDPOINT, {});
    }
}
exports.ClientHandshake = ClientHandshake;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xpZW50LWhhbmRzaGFrZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9oYW5kc2hha2UvY2xpZW50LWhhbmRzaGFrZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwyQ0FBMkQ7QUFLM0QsTUFBYSxlQUFlO0lBQ3hCLFlBQTJCLE1BQXFCO1FBQXJCLFdBQU0sR0FBTixNQUFNLENBQWU7SUFBRyxDQUFDO0lBTTdDLEtBQUssQ0FBQyxPQUFPLENBQUMsT0FBZTtRQUNoQyxNQUFNLElBQUksQ0FBQyxNQUFNLENBQUMsT0FBTyxFQUFFLENBQUM7UUFFNUIsT0FBTyxJQUFJLE9BQU8sQ0FBQyxPQUFPLENBQUMsRUFBRTtZQUl6QixNQUFNLGNBQWMsR0FBRyxXQUFXLENBQUMsR0FBRyxFQUFFLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQztZQUV4RSxNQUFNLFlBQVksR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQyxPQUFPLEdBQUcseUJBQWEsRUFBRSxHQUFHLEVBQUU7Z0JBQ3JFLE9BQU8sRUFBRSxDQUFDO2dCQUtWLGFBQWEsQ0FBQyxjQUFjLENBQUMsQ0FBQztnQkFFOUIsWUFBWSxDQUFDLFdBQVcsRUFBRSxDQUFDO1lBQy9CLENBQUMsQ0FBQyxDQUFDO1lBS0gsSUFBSSxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUMzQixDQUFDLENBQUMsQ0FBQztJQUNQLENBQUM7SUFFTyxRQUFRLENBQUMsT0FBZTtRQUM1QixJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxPQUFPLEdBQUcseUJBQWEsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNyRCxDQUFDO0NBQ0o7QUFyQ0QsMENBcUNDIn0=